import React from "react"
import { Badge } from "reactstrap"
import { Link } from "react-router-dom"
import { format } from "date-fns"
import "@formatjs/intl-numberformat/polyfill"
import StatusMap from "helpers/statusMap"

const PublicNo = original => {
  const countPublicacoes = original?.Processo?.Publicacoes.length
  if (countPublicacoes > 1) {
    return (
      <Badge
        pill
        color="info"
        onClick={() => {
          setmodal(!modal)
        }}
        style={{ cursor: "pointer" }}
        className="font-size-14"
      >
        {" "}
        +{countPublicacoes - 1}
      </Badge>
    )
  }
}

const PublicTags = cell => {
  const cores = [
    "primary",
    "info",
    "warning",
    "success",
    "danger",
    "dark",
    "pink",
    "secondary",
  ]

  const tagCell = cell.value.map(element => [
    <Badge key={element.Id} color={element.Estilo} className="me-1">
      {element.Titulo}
    </Badge>,
  ])

  return tagCell
}

const PoloPassivo = cell => {
  return cell.value ? cell.value : ""
}

const PublicValor = cell => {
  return cell.value
    ? Number(cell.value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })
    : ""
}

const PublicDate = cell => {
  return cell.value ? format(new Date(cell.value), "dd/MM/yyyy") : ""
}

const Prioridade = cell => {
  return cell.value ? cell.value : ""
}

const PublicStatus = cell => {
  switch (cell.value) {
    case StatusMap.Novo.value:
      return <Badge className="bg-warning">{StatusMap.Novo.text}</Badge>
    case StatusMap.Incompleto.value:
      return <Badge className="bg-info">{StatusMap.Incompleto.text}</Badge>
    case StatusMap.EmAprovação.value:
      return <Badge className="bg-danger">{StatusMap.EmAprovação.text}</Badge>
    case StatusMap.Concluido.value:
      return <Badge className="bg-success">{StatusMap.Concluido.text}</Badge>
    case StatusMap.Manual.value:
      return <Badge className="bg-dark">{StatusMap.Manual.text}</Badge>
    case StatusMap.Monitorado.value:
      return <Badge className="bg-primary">{StatusMap.Monitorado.text}</Badge>
    case StatusMap.NaoMonitorado.value:
      return (
        <Badge className="bg-secondary">{StatusMap.NaoMonitorado.text}</Badge>
      )
    case StatusMap.NaoPriorizado.value:
      return <Badge className="bg-light">{StatusMap.NaoPriorizado.text}</Badge>
    case StatusMap.Excluido.value:
      return (
        <Badge className="bg-danger-subtle">{StatusMap.Excluido.text}</Badge>
      )
    default:
      return <Badge className="bg-secondary">{cell.value}</Badge>
  }
}

const LeadStatus = cell => {
  switch (cell.value) {
    case "Pendente de Envio":
      return <Badge className="bg-warning">Pendente de Envio</Badge>
    case "Falha no Envio":
      return <Badge className="bg-danger">Falha no Envio</Badge>
    case "Enviado":
      return <Badge className="bg-success">Enviado</Badge>
    // default:
    //     return <Badge className="bg-warning">{cell.value}</Badge>
  }
}

export {
  PublicNo,
  PublicTags,
  PoloPassivo,
  PublicValor,
  PublicDate,
  Prioridade,
  PublicStatus,
  LeadStatus,
}
